import css from 'styled-jsx/css'
import { colors, fontSizes, measurements } from 'theme'

export default css`
  .portals-container {
    max-width: 70rem;
    margin: 0 auto;
    width: 95%;
    max-width: ${measurements.containerSize};
    justify-content: space-between;
    margin: 2rem auto;
    background: ${colors.white};
    padding: 2rem;
    border: solid 1px ${colors.border};
  }

  .portals-container .portals-title {
    font-size: ${fontSizes.h3};
  }
`
